import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { find, findIndex, map } from 'lodash'

import { filterLabelingItems, toggleFileFinished, invalidateCompletedItems } from '@/stores/slices/Labeling/thunks/files'
import { updateComments, updateLabelingItemStatus } from '@/stores/slices/Labeling/reducers/common'
import { LabelingState } from '@/stores/slices/Labeling/types'
import { transformAnnotObjects } from '@/stores/slices/Labeling/utils'

export const filesExtraReducers = (builder: ActionReducerMapBuilder<LabelingState>) => {
  builder.addCase(filterLabelingItems.pending, (state) => {
    state.isInProgress = true
  })
  builder.addCase(filterLabelingItems.fulfilled, (state, action) => {
    const { targetLabelingItemId } = action.meta.arg
    const { itemList, filters } = action.payload
    const annotation: LabelingState['annotation'] = {}

    const initAnnotList = itemList.length === 0 ? [] : itemList.slice(0, 5)

    initAnnotList.forEach((f) => {
      annotation[f._id] = { status: f.status, object: transformAnnotObjects(f.labelingObjects || []) }
    })

    if (targetLabelingItemId) {
      const targetFileIdx = findIndex(itemList, { _id: targetLabelingItemId })
      if (targetFileIdx !== -1) {
        const targetLabelingItem = itemList[targetFileIdx]
        annotation[targetLabelingItemId] = {
          status: targetLabelingItem.status,
          object: transformAnnotObjects(targetLabelingItem.labelingObjects || []),
        }
        state.currentIndex = targetFileIdx
      }
    } else {
      // 기본 0번째
      state.currentIndex = 0
    }

    state.originalFiles = map(state.originalFiles, (file) => {
      const found = find(itemList, { _id: file?._id })
      return found ?? file
    })

    state.files = itemList
    state.fileFilter = filters
    state.annotation = annotation

    updateComments(state, itemList)

    state.isInProgress = false
  })
  builder.addCase(toggleFileFinished.fulfilled, (state, action) => {
    updateLabelingItemStatus(state, {
      itemId: action.payload._id,
      updatedStatus: action.payload.status,
    })
  })
  builder.addCase(invalidateCompletedItems.fulfilled, (state, action) => {
    state.originalFiles = map(state.originalFiles, (file) => {
      const found = find(action.payload, { _id: file?._id })
      return found ?? file
    })
  })
}
